<template>
    <div class="version2-header">
        <img src="../../../../static/version2/左边板块标题样式.png" alt="">
        <span>{{ title }}</span>
    </div>
</template>
<script>
export default {
  props: {
    title: String
  },
  data() {
    return {

    }
  }
}
</script>
